/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Commodities,
  CommoditiesParams,
  Commodity,
  CommodityPricePointsList,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Commodities list
 */
export const commodities = (
    params?: MaybeRefOrGetter<CommoditiesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Commodities>(
      {url: `/commodities`, method: 'GET',
        params, signal
    },
      );
    }




export const getCommoditiesQueryKey = (params?: MaybeRefOrGetter<CommoditiesParams>,) => {
    return [
    'commodities', ...(params ? [params] : [])
    ] as const;
    }


export const getCommoditiesQueryOptions = <TData = Awaited<ReturnType<typeof commodities>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<CommoditiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodities>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCommoditiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commodities>>> = ({ signal }) => commodities(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commodities>>, TError, TData>
}

export type CommoditiesQueryResult = NonNullable<Awaited<ReturnType<typeof commodities>>>
export type CommoditiesQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Commodities list
 */

export function useCommodities<TData = Awaited<ReturnType<typeof commodities>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<CommoditiesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodities>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommoditiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Commodity detail
 */
export const commodity = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<Commodity>(
      {url: `/commodities/${slug}`, method: 'GET', signal
    },
      );
    }




export const getCommodityQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'commodities',slug
    ] as const;
    }


export const getCommodityQueryOptions = <TData = Awaited<ReturnType<typeof commodity>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodity>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCommodityQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commodity>>> = ({ signal }) => commodity(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commodity>>, TError, TData>
}

export type CommodityQueryResult = NonNullable<Awaited<ReturnType<typeof commodity>>>
export type CommodityQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Commodity detail
 */

export function useCommodity<TData = Awaited<ReturnType<typeof commodity>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodity>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommodityQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Commodity Price History
 */
export const commodityPriceHistory = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<CommodityPricePointsList>(
      {url: `/commodities/${slug}/price-history`, method: 'GET', signal
    },
      );
    }




export const getCommodityPriceHistoryQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'commodities',slug,'price-history'
    ] as const;
    }


export const getCommodityPriceHistoryQueryOptions = <TData = Awaited<ReturnType<typeof commodityPriceHistory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodityPriceHistory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getCommodityPriceHistoryQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof commodityPriceHistory>>> = ({ signal }) => commodityPriceHistory(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof commodityPriceHistory>>, TError, TData>
}

export type CommodityPriceHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof commodityPriceHistory>>>
export type CommodityPriceHistoryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Commodity Price History
 */

export function useCommodityPriceHistory<TData = Awaited<ReturnType<typeof commodityPriceHistory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof commodityPriceHistory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCommodityPriceHistoryQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






